import React, { Component } from 'react';
import InputTextField from 'components/common/InputTextField';
import { SANITIZATION_TYPES } from '../../common/sanitizationTypes';

export default class ModalContentConfigFormInputs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            themeName: props.values && props.values.themeName,
            themeCode: props.values && props.values.themeCode,
            themeComment: props.values && props.values.themeComment
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(elemName, elemValue) {
        this.setState(
            {
                [elemName]: elemValue
            },
            () => {
                this.props.onChange(this.state);
            }
        );
    }

    render() {
        const { contentType } = this.props;

        return (
            <div>
                {this.props.type === 'save' && (
                    <InputTextField
                        sparkInputProps={{
                            errorMessage:
                                this.props.errorForm &&
                                _.get(this.props, 'values.themeName', '') === '' &&
                                'Field is required',
                            label: `${contentType} name*`
                        }}
                        name="themeName"
                        onChange={value => this.handleChange('themeName', value)}
                        placeholder={`${contentType} name*`}
                        value={this.props.values && this.props.values.themeName}
                    />
                )}
                {this.props.type === 'save' && (
                    <InputTextField
                        sparkInputProps={{
                            errorMessage:
                                this.props.errorForm &&
                                _.get(this.props, 'values.themeCode', '') === '' &&
                                'Field is required',
                            label: `${contentType} code*`
                        }}
                        name={`"themeCode"`}
                        onChange={value => this.handleChange('themeCode', value)}
                        placeholder={`${contentType} code*`}
                        value={this.props.values && this.props.values.themeCode}
                    />
                )}
                <InputTextField
                    // errorMessage={this.props.errorForm && _.get(this.props, 'values.themeComment', '') === '' && 'Field is required'}
                    sparkInputProps={{
                        label: 'Comments'
                    }}
                    name={`"themeComment"`}
                    onChange={value => this.handleChange('themeComment', value)}
                    placeholder="Comments..."
                    sanitizationType={SANITIZATION_TYPES.BLACK_LIST}
                    replaceWith={{ '&lt;': '<', '&gt;': '>' }}
                    value={this.props.values && this.props.values.themeComment}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/modals/modalContent/ModalContentConfigFormInputs.js